import React, { useState } from 'react';

import { ReactComponent as Heart } from '@assets/images/header/heart.svg';

import { YandexShare } from '@ui/moleculs/atoms/YandexShare';

import styles from './index.module.css';


type RoundedLinkProps = {
  id: string;
  color: string;
};

const colors: { [key: string]: any } = {
  'light': {
    default: 'text-white',
    hover: 'hover:text-menu-number-active',
  },
  'dark': {
    default: 'text-social-blue',
    hover: 'hover:text-ltblue',
  },
};

export const RoundedLink: React.FC<RoundedLinkProps> = ({ ...props }) => {
  const { id, color } = props;
  const [open, setOpen] = useState(false);

  const toggleOpen = () => {
    setOpen(!open);
  };

  return (
    <div
      className={`
        ${color? `fixed` : `absolute`}
        right-0
        bottom-0
        z-3
        cursor-pointer
      `}
      onClick={toggleOpen}
    >
      <div
        className={`
          absolute
          top-1/2
          -mt-3
          flex
          transform
          origin-right
          transition
          right-20
          z-3
          ${open ? `opacity-100 scale-100` : `opacity-0 scale-0`}
        `}
      >
        <YandexShare id={id} color={color} />

        {/*
        <a
          className={`
            p-2.5
            -mt-2.5
            ${color? colors.light.default + ` ` + colors.light.hover : colors.dark.default + ` ` + colors.dark.hover}
            transition
          `}
          href="https://facebook.com"
          rel="noopener noreferrer"
        ><FB className="fill-current" /></a>
        <a
          className={`
            p-2.5
            -mt-2.5
            ${color? colors.light.default + ` ` + colors.light.hover : colors.dark.default + ` ` + colors.dark.hover}
            transition
          `}
          href="https://ok.ru/"
          rel="noopener noreferrer"
        ><OK className="fill-current" /></a>
        <a
          className={`
            p-2.5
            -mt-2.5
            ${color? colors.light.default + ` ` + colors.light.hover : colors.dark.default + ` ` + colors.dark.hover}
            transition
          `}
          href="https://web.telegram.org"
          rel="noopener noreferrer"
        ><Telegram className="fill-current" /></a>
        <a
          className={`
            p-2.5
            -mt-2.5
            ${color? colors.light.default + ` ` + colors.light.hover : colors.dark.default + ` ` + colors.dark.hover}
            transition
          `}
          href="https://twitter.com"
          rel="noopener noreferrer"
        ><TW className="fill-current" /></a>
        <a
          className={`
            p-2.5
            -mt-2.5
            ${color? colors.light.default + ` ` + colors.light.hover : colors.dark.default + ` ` + colors.dark.hover}
            transition
          `}
          href="https://vk.com/"
          rel="noopener noreferrer"
        ><VK className="fill-current" /></a>
        */}
      </div>
      <Heart
        width={24}
        height={24}
        className={`
          ${styles.heart}
          fill-current
          ${open ? (color? colors.light.default : colors.dark.default) : `text-opacity`}
          ${color? `stroke-white` : `stroke-social-blue`}
          absolute
          left-2/4
          top-2/4
          transform
          -translate-x-1/2
          -translate-y-1/2
        `}
      />
      <div
        id="circle"
        className={`
          ${styles.circle}
          transition
          ${open ? `opacity-0` : `opacity-100`}
          relative
          left-0
          top-0
          overflow-hidden
        `}
      >
        <svg
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xlinkHref="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          width="108px"
          height="108px"
          viewBox="0 0 300 300"
          enableBackground="new 0 0 300 300"
          xmlSpace="preserve"
          className={`
            select-none
          `}
        >
          <defs>
            <path id="circlePath" d="M 150, 150 m -60, 0 a 60,60 0 0,1 120,0 a 60,60 0 0,1 -120,0 "/>
          </defs>
          <circle
            cx="150"
            cy="100"
            r="75"
            fill="none"
          />
          <g>
            <use xlinkHref="#circlePath" fill="none"/>
            <text fill={color? `#FFFFFF` : `#013D84`}>
              <textPath xlinkHref="#circlePath" fontSize="1.315em">п о д е л и т ь с я&nbsp;&nbsp;п о д е л и т ь с я</textPath>
            </text>
          </g>
        </svg>
      </div>
    </div>
  );
}